"use client";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { flagEnabled } from "~/lib/flags";

// Only downloaded when the flag is on.
const Panel = dynamic(() => import("./panel"), { ssr: false });

/** Experimental AI assistant (flag "ai"). Turn on for one browser with ?ff=ai, off with ?ff=-ai. */
export default function AssistantLauncher() {
  const [enabled, setEnabled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setEnabled(flagEnabled("ai"));
  }, []);
  if (!enabled) return null;
  if (open) return <Panel onClose={() => setOpen(false)} />;
  return (
    <button
      onClick={() => setOpen(true)}
      aria-label="Ask the PalDeck assistant"
      className="fixed bottom-4 right-4 z-40 flex items-center gap-2 rounded-full bg-deck-cyan px-4 py-3 text-sm font-semibold text-deck-bg shadow-xl transition hover:brightness-110"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5 fill-none stroke-current stroke-2" aria-hidden>
        <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12Z" />
      </svg>
      Ask AI
    </button>
  );
}
